import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Mousewheel, FreeMode } from 'swiper';

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import styles from '../../styles/common/features.module.css'
import { TalkToUsCustomButton } from '../qbStrap'
import { useRouter } from 'next/router'
import VerificationPopup from '../modals/VerificationPopup';

const FeaturesSection = ({   setHeading, data, centerImages, title }) => {
  const [showMore, setShowMore] = useState({ state: false, idx: null });
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [animatedSections, setAnimatedSections] = useState(new Set());
  const [mobileView, setmobileView] = useState(1);
  const [demoModal, setDemoModal] = useState(false);
  const [formHeading, setFormHeading] = useState("");

  const scrollRef = useRef();
  const sectionRefs = useRef([]);
  
  const isOddCount = data.length % 2 !== 0;
  const centerImageIndex = isOddCount ? 1 : Math.ceil(data.length / 2) - 1; 

  const openDemoModal = () => {
    // Use the provided `title` when available, otherwise keep the default.
    setFormHeading(title || "We'll call you soon!");
    setDemoModal(true);
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current
    scrollContainer.addEventListener("scroll", () => {
      scrollContainer.scrollTop && setShowMore({ state: false })
    });
  }, []);
  const setWindowDimensions = () => {
    window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
  };

  useEffect(() => {
    setWindowDimensions();
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const sectionId = entry.target.getAttribute('data-section-id');
          if (entry.isIntersecting && !animatedSections.has(sectionId)) {
            setVisibleSections(prev => new Set([...prev, sectionId]));
            setTimeout(() => {
              setAnimatedSections(prev => new Set([...prev, sectionId]));
            }, 3000);
          }
        });
      }

    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [data]);




  return (
    <>
      <div className={styles.featuresSection}>
        <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />

        <div className={styles.card_wrapper} ref={scrollRef} style={{ margin: mobileView ? "0 2rem" : "0rem 14rem", padding: mobileView ? "5rem 0rem " : "5rem 0" }}>
          {
            data?.map((ele, idx) => {
              const isEven = idx % 2 === 0;
              const isVisible = visibleSections.has(ele.id?.toString());
              const isAnimated = animatedSections.has(ele.id?.toString());

              return (
                <React.Fragment key={ele.id || idx}>
                  <div
                    ref={(el) => sectionRefs.current[idx] = el}
                    data-section-id={ele.id}
                    className={styles.feature_container}
                    style={{ position: "sticky", flexDirection: !mobileView && !isEven ? "row-reverse" : "row" }}
                  >
                    <div className={styles.left_section}>
                      {
                        ele?.icon &&
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', }}>
                          <div className={styles.icon}><Image src={ele?.icon} alt='icon' fill /></div>
                          <div className={styles.tag_text}>{ele?.tag}</div>
                        </div>
                      }
                      <h4 className={styles.feature_heading}>{ele?.title}</h4>
                      {
                        mobileView ?
                          <div className={styles.right_side} style={{ margin: "4rem 0 5rem 0" }}>
                            <div className={styles.stack_container}>
                              {ele?.Image1 && (
                                <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_left_to_top_right : ''} ${isAnimated ? styles.animate_bottom_left_to_top_right : ''}`} style={{ height: ele?.Image1?.imageHeight, width: ele?.Image1?.imageWidth, bottom: ele?.Image1?.bottom, right: ele?.Image1?.right, top: ele?.Image1?.top, left: ele?.Image1?.left, animationDelay: (isVisible && !isAnimated) ? '0s' : 'unset', transform: isAnimated ? 'translate(20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image1?.src} fill alt='image1' /></div>
                              )}
                              {ele?.Image2 && (
                                <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_left_to_top_right : ''} ${isAnimated ? styles.animate_bottom_left_to_top_right : ''}`} style={{ height: ele?.Image2?.imageHeight, width: ele?.Image2?.imageWidth, bottom: ele?.Image2?.bottom, right: ele?.Image2?.right, top: ele?.Image2?.top, left: ele?.Image2?.left, animationDelay: (isVisible && !isAnimated) ? '0.5s' : 'unset', transform: isAnimated ? 'translate(20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image2?.src} fill alt='image2' /></div>
                              )}
                              {ele?.Image3 && (
                                <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_right_to_top_left : ''} ${isAnimated ? styles.animate_bottom_right_to_top_left : ''}`} style={{ height: ele?.Image3?.imageHeight, width: ele?.Image3?.imageWidth, bottom: ele?.Image3?.bottom, right: ele?.Image3?.right, top: ele?.Image3?.top, left: ele?.Image3?.left, animationDelay: (isVisible && !isAnimated) ? '0s' : 'unset', transform: isAnimated ? 'translate(-20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image3?.src} fill alt='image3' /></div>
                              )}
                              {ele?.Image4 && (
                                <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_right_to_top_left : ''} ${isAnimated ? styles.animate_bottom_right_to_top_left : ''}`} style={{ height: ele?.Image4?.imageHeight, width: ele?.Image4?.imageWidth, bottom: ele?.Image4?.bottom, right: ele?.Image4?.right, top: ele?.Image4?.top, left: ele?.Image4?.left, animationDelay: (isVisible && !isAnimated) ? '1.5s' : 'unset', transform: isAnimated ? 'translate(-20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image4?.src} fill alt='image4' /></div>
                              )}

                              <div
                                className={styles.stack_card}
                                style={{
                                  height: ele?.imageHeight,
                                  width: ele?.imageWidth,
                                  maxWidth: '100%',
                                  bottom: '0rem',
                                  left: ele?.imageWidth ? '50%' : undefined,
                                  right: ele?.imageWidth ? 'auto' : '0rem',
                                  transform: ele?.imageWidth ? 'translateX(-50%)' : undefined,
                                }}
                              >
                                <Image src={ele?.image} alt={ele?.title} fill />
                              </div>
                            </div>
                          </div> : null
                      }
                      <p className={styles.feature_body_text} style={{ color: "#5a5a5a" }}>{ele?.desc}</p>
                      <div className={styles.readMoreParentDiv}>
                        {
                          ele?.points?.map((item, index) => {
                            return (
                              <div key={index} className={styles.feature_body_text}
                                style={{
                                  // borderLeft: `4px solid ${ele?.tagColor}`, paddingLeft: "1.25rem", marginTop: "1.5rem",
                                  borderLeft: '3px solid #F68E1E', paddingLeft: "1.25rem", marginTop: "1.5rem",
                                }}>
                                {item}
                              </div>
                            )
                          })
                        }
                      </div>
                      <TalkToUsCustomButton
                        text={ele?.btnText}
                        style={mobileView ? { margin: '1rem 0' } : { marginTop: '3rem' }}
                        onClick={() => {
                          setFormHeading(ele?.btnText || "We'll call you soon!");
                          setDemoModal(true);
                        }} />
                    </div>
                    {
                      !mobileView &&
                      <div className={styles.right_side}>
                        <div className={styles.stack_container}>
                          <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_left_to_top_right : ''} ${isAnimated ? styles.animate_bottom_left_to_top_right : ''}`} style={{ height: ele?.Image1?.imageHeight, width: ele?.Image1?.imageWidth, bottom: ele?.Image1?.bottom, right: ele?.Image1?.right, top: ele?.Image1?.top, left: ele?.Image1?.left, animationDelay: (isVisible && !isAnimated) ? '0s' : 'unset', transform: isAnimated ? 'translate(20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image1?.src} fill alt='image1' /></div>
                          <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_left_to_top_right : ''} ${isAnimated ? styles.animate_bottom_left_to_top_right : ''}`} style={{ height: ele?.Image2?.imageHeight, width: ele?.Image2?.imageWidth, bottom: ele?.Image2?.bottom, right: ele?.Image2?.right, top: ele?.Image2?.top, left: ele?.Image2?.left, animationDelay: (isVisible && !isAnimated) ? '0.5s' : 'unset', transform: isAnimated ? 'translate(20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image2?.src} fill alt='image2' /></div>
                          <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_right_to_top_left : ''} ${isAnimated ? styles.animate_bottom_right_to_top_left : ''}`} style={{ height: ele?.Image3?.imageHeight, width: ele?.Image3?.imageWidth, bottom: ele?.Image3?.bottom, right: ele?.Image3?.right, top: ele?.Image3?.top, left: ele?.Image3?.left, animationDelay: (isVisible && !isAnimated) ? '1s' : 'unset', transform: isAnimated ? 'translate(-20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image3?.src} fill alt='image3' /></div>
                          <div className={`${styles.stack_card_image} ${(isVisible && !isAnimated) ? styles.animate_bottom_right_to_top_left : ''} ${isAnimated ? styles.animate_bottom_right_to_top_left : ''}`} style={{ height: ele?.Image4?.imageHeight, width: ele?.Image4?.imageWidth, bottom: ele?.Image4?.bottom, right: ele?.Image4?.right, top: ele?.Image4?.top, left: ele?.Image4?.left, animationDelay: (isVisible && !isAnimated) ? '1.5s' : 'unset', transform: isAnimated ? 'translate(-20px, -20px)' : undefined, opacity: isAnimated ? 1 : undefined }}><Image src={ele?.Image4?.src} fill alt='image4' /></div>


                          <div className={styles.stack_card} style={{ height: ele?.imageHeight, width: mobileView ? "100%" : ele?.imageWidth, bottom: '2rem', right: '2.5rem' }}><Image src={ele?.image} alt={ele?.title} fill /></div>
                        </div>
                      </div>
                    }
                  </div>

                  {idx === centerImageIndex && centerImages && centerImages.length > 0 && (
                    !mobileView ? (
                      <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '4rem 3rem',
                        maxWidth: '100%',
                        height: '42rem',
                        position: 'relative',
                        cursor: 'pointer',
                      }} onClick={openDemoModal}>
                        {/* <Swiper
                          modules={[Autoplay, Pagination, Navigation]}
                          spaceBetween={30}
                          slidesPerView={1}
                          autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                          }}
                          pagination={{
                            clickable: true,
                          }}
                          navigation={!mobileView}
                          loop={centerImages.length > 1}
                          // className={styles.centerImageSwiper}
                        > */}
                          {centerImages.map((image, index) => (
                            // <SwiperSlide key={index}>
                              <div className={styles.centerImages}>
                                <Image
                                  src={image}
                                  alt={`Pet Store Center Image ${index + 1}`}
                                  fill
                                  style={{ objectFit: 'contain' }}
                                />
                              </div>
                            // </SwiperSlide>
                          ))}
                        {/* </Swiper> */}
                      </div>
                    ) : (
                      <>
                        {centerImages.map((image, index) => (
                          <div
                            key={index}
                            style={{ position: 'relative', width:'100%', height: "60rem", cursor: 'pointer' }}
                            onClick={openDemoModal}
                          >
                            <Image
                              src={image}
                              alt={`Pet Store Center Image ${index + 1}`}
                              fill
                              style={{ objectFit: 'contain' }}
                            />
                          </div>
                        ))}
                      </>
                    )
                  )}
                </React.Fragment>
              )
            })
          }
        </div>
      </div>
    </>
  )
}

export default FeaturesSection